class EinzelticketController {
  constructor($rootScope, toastr, emittentenService, $location, $anchorScroll) {
    "ngInject";
    this.name = 'einzelticket';
    this.toastr = toastr;
    this.emittentenService = emittentenService;
    this.$location = $location;
    this.$anchorScroll = $anchorScroll;
    this.disabled = [false, true];
    this.active = 0;
    this.emailChecked = true;
    this.form = {
      user_type: 4,
      /*
      section: '',
      c: '',
      anmeldung_typ: '',
      teilnehmer_teilnahme_tage: '',
      teilnehmer_benutztercode: '',
      teilnehmer_unternehmensname: '',
      person_anrede: '',
      person_titel: '',
      person_vorname: '',
      person_nachname: '',
      teilnehmer_branche: '',
      person_unternehmenstitel: '',
      person_telefon_land: '',
      person_telefon_vorwahl: '',
      person_telefon_nummer: '',
      person_telefon_durchwahl: '',
      person_email: '',
      person_ccmail: '',
      person_webseite: '',
      adresse_strasse: '',
      adresse_postleitzahl: '',
      adresse_stadt: '',
      */
      adresse_land: '55',
      /*
      teilnehmer_industriegruppe_branche: '',
      teilnehmer_industriegruppe_id: '',
      teilnehmer_industriegruppe_sonstige: '',
      teilnehmer_details_kapitalisierung: '',
      teilnehmer_details_kapitalbedarf: '',
      teilnehmer_details_boersenplatz: '',
      teilnehmer_details_unternehmensgroesse: '',
      teilnehmer_gebuehren2: '',
      _present_teilnehmer_newsletter: '',
      _present_teilnehmer_newsletter_sponsoren: ''
      */
    };

    emittentenService.getSegmentTags($rootScope.language).then((result) => {
      this.segmentTags = result;
      return result;
    }, (response) => {
      console.error(response);
    });

    emittentenService.getCountries($rootScope.language).then((result) => {
      this.countries = result;
      return result;
    }, (response) => {
      console.error(response);
    });

    emittentenService.getEventPackets($rootScope.language, 2).then((result) => {
      console.dir(result);
      if (result.length) {
        this.eventPackets = result;
        this.form.analyst_paket = result[0].id;
      }
      else this.toastr.error('Für diesen Anmeldetyp wurde noch kein Paket angelegt. Bitte kehren Sie später zurück.');
      return result;
    }, (response) => {
      console.error(response);
    });

    if ($rootScope.language == 'de') {
      this.industries = [{
        "id": 1,
        "name": "Automobilbranche",
        "industriegruppen": [{
          "id": 2,
          "name": "Automobilhersteller"
        }, {
          "id": 1,
          "name": "Autoteile und -zubeh\u00f6r"
        }]
      }, {
        "id": 2,
        "name": "Banken",
        "industriegruppen": [{
          "id": 4,
          "name": "Hypothekenbanken"
        }, {
          "id": 3,
          "name": "Kreditbanken"
        }, {
          "id": 67,
          "name": "Sonstige Banken"
        }]
      }, {
        "id": 3,
        "name": "Bauindustrie",
        "industriegruppen": [{
          "id": 6,
          "name": "Bau- und Ingenieurswesen"
        }, {
          "id": 5,
          "name": "Baumaterialien"
        }]
      }, {
        "id": 4,
        "name": "Chemie",
        "industriegruppen": [{
          "id": 7,
          "name": "Chemieprodukte, Zwischenerzeugnisse"
        }, {
          "id": 9,
          "name": "Industriegase"
        }, {
          "id": 8,
          "name": "Spezial-Chemieprodukte"
        }]
      }, {
        "id": 5,
        "name": "Energie & Rohstoffe",
        "industriegruppen": [{
          "id": 62,
          "name": "Allgemeine Energieversorgung"
        }, {
          "id": 11,
          "name": "Bergbau"
        }, {
          "id": 59,
          "name": "Elektrizit\u00e4tsversorgung"
        }, {
          "id": 10,
          "name": "Forst- und Papierprodukte"
        }, {
          "id": 13,
          "name": "Stahl & Metalle"
        }, {
          "id": 60,
          "name": "Wasserversorgung"
        }, {
          "id": 12,
          "name": "\u00d6l & Erdgas"
        }, {
          "id": 61,
          "name": "\u00d6l- und Gasversorgung"
        }]
      }, {
        "id": 6,
        "name": "Finanzdienstleistungen",
        "industriegruppen": [{
          "id": 14,
          "name": "Allgemeine Finanzdienstleister"
        }, {
          "id": 63,
          "name": "Beteiligungsgesellschaften PE\/VC"
        }, {
          "id": 15,
          "name": "Immobilien"
        }, {
          "id": 16,
          "name": "Wertpapierhandel"
        }]
      }, {
        "id": 19,
        "name": "Green Technology",
        "industriegruppen": [{
          "id": 65,
          "name": "Agrarwirtschaft & Ressourcenschonung"
        }, {
          "id": 66,
          "name": "Energieeffizienz & Emissionsminderung "
        }, {
          "id": 64,
          "name": "Erneuerbare Energien"
        }]
      }, {
        "id": 7,
        "name": "Handel",
        "industriegruppen": [{
          "id": 19,
          "name": "Internethandel"
        }, {
          "id": 20,
          "name": "Kaufh\u00e4user"
        }, {
          "id": 18,
          "name": "Lebensmittel- und Drogeriem\u00e4rkte, Apotheken"
        }, {
          "id": 21,
          "name": "Spezialisierte Einzelhandel"
        }, {
          "id": 17,
          "name": "Versandhandel"
        }]
      }, {
        "id": 20,
        "name": "Immobilien",
        "industriegruppen": [{
          "id": 68,
          "name": "Immobilien"
        }]
      }, {
        "id": 8,
        "name": "Industrie",
        "industriegruppen": [{
          "id": 25,
          "name": "Allgemeine Industrieunternehmen"
        }, {
          "id": 28,
          "name": "Container & Verpackungen"
        }, {
          "id": 23,
          "name": "Gro\u00dfmaschinenbau"
        }, {
          "id": 22,
          "name": "High-Tech Industrieanlagen"
        }, {
          "id": 24,
          "name": "Industriemaschinenbau"
        }, {
          "id": 27,
          "name": "Industrieprodukte & Dienstleistungen"
        }]
      }, {
        "id": 9,
        "name": "Konsumg\u00fcter",
        "industriegruppen": [{
          "id": 31,
          "name": "Eigenheimbau & M\u00f6bel"
        }, {
          "id": 33,
          "name": "Freizeitg\u00fcter & Dienstleistungen"
        }, {
          "id": 39,
          "name": "Getr\u00e4nke"
        }, {
          "id": 32,
          "name": "Haushaltsger\u00e4te und -waren"
        }, {
          "id": 29,
          "name": "Kleidung & Schuhe"
        }, {
          "id": 34,
          "name": "Kosmetika"
        }, {
          "id": 40,
          "name": "Nahrungsmittel, Tabak"
        }, {
          "id": 30,
          "name": "Unterhaltungselektronik"
        }]
      }, {
        "id": 10,
        "name": "Medien",
        "industriegruppen": [{
          "id": 37,
          "name": "Film & Unterhaltung"
        }, {
          "id": 36,
          "name": "Rundfunk & Fernsehen"
        }, {
          "id": 38,
          "name": "Verlags- und Druckereiwesen"
        }, {
          "id": 35,
          "name": "Werbung"
        }]
      }, {
        "id": 12,
        "name": "Pharma & Biotech",
        "industriegruppen": [{
          "id": 43,
          "name": "Biotechnologie"
        }, {
          "id": 42,
          "name": "Gesundheitswesen"
        }, {
          "id": 44,
          "name": "Medizintechnik"
        }, {
          "id": 41,
          "name": "Pharmazeutika"
        }]
      }, {
        "id": 13,
        "name": "Software",
        "industriegruppen": [{
          "id": 46,
          "name": "IT-Dienstleistungen"
        }, {
          "id": 45,
          "name": "Internet"
        }, {
          "id": 47,
          "name": "Software"
        }]
      }, {
        "id": 14,
        "name": "Technologie",
        "industriegruppen": [{
          "id": 49,
          "name": "Elektronische Komponenten & Hardware"
        }, {
          "id": 50,
          "name": "Halbleiterprodukte"
        }, {
          "id": 48,
          "name": "Kommunikationstechnologie"
        }]
      }, {
        "id": 15,
        "name": "Telekommunikation",
        "industriegruppen": [{
          "id": 51,
          "name": "Festnetz-Telekommunikation"
        }, {
          "id": 52,
          "name": "Mobilfunk-Telekommunikation"
        }, {
          "id": 53,
          "name": "Telekommunikations-Dienstleistungen"
        }]
      }, {
        "id": 16,
        "name": "Transport & Logistik",
        "industriegruppen": [{
          "id": 54,
          "name": "Fluggesellschaften"
        }, {
          "id": 55,
          "name": "Logistik"
        }, {
          "id": 56,
          "name": "Transport-Dienstleistungen"
        }]
      }, {
        "id": 17,
        "name": "Versicherungen",
        "industriegruppen": [{
          "id": 58,
          "name": "R\u00fcckversicherungen"
        }, {
          "id": 57,
          "name": "Versicherungen"
        }]
      }];
    } else {
      this.industries = [{
        "id": 1,
        "name": "Automobile",
        "industriegruppen": [{
          "id": 1,
          "name": "Auto Parts & Equipment"
        }, {
          "id": 2,
          "name": "Automobile Manufacturers"
        }]
      }, {
        "id": 2,
        "name": "Banks",
        "industriegruppen": [{
          "id": 3,
          "name": "Credit Banks"
        }, {
          "id": 4,
          "name": "Mortgage Banks"
        }, {
          "id": 67,
          "name": "Other Banks"
        }]
      }, {
        "id": 5,
        "name": "Basic Resources",
        "industriegruppen": [{
          "id": 59,
          "name": "Electricity"
        }, {
          "id": 10,
          "name": "Forest & Paper Products"
        }, {
          "id": 11,
          "name": "Mining"
        }, {
          "id": 62,
          "name": "Multi-Utilites"
        }, {
          "id": 12,
          "name": "Oil & Gas"
        }, {
          "id": 61,
          "name": "Oil & Gas (Distribution)"
        }, {
          "id": 13,
          "name": "Steel & Other Metals"
        }, {
          "id": 60,
          "name": "Water"
        }]
      }, {
        "id": 4,
        "name": "Chemicals",
        "industriegruppen": [{
          "id": 7,
          "name": "Chemicals, Commodity"
        }, {
          "id": 8,
          "name": "Chemicals, Specialty"
        }, {
          "id": 9,
          "name": "Industrial Gases"
        }]
      }, {
        "id": 3,
        "name": "Construction",
        "industriegruppen": [{
          "id": 5,
          "name": "Building Materials"
        }, {
          "id": 6,
          "name": "Construction & Engineering"
        }]
      }, {
        "id": 9,
        "name": "Consumer",
        "industriegruppen": [{
          "id": 39,
          "name": "Beverages"
        }, {
          "id": 29,
          "name": "Clothing & Footwear"
        }, {
          "id": 30,
          "name": "Consumer Electronics"
        }, {
          "id": 40,
          "name": "Food"
        }, {
          "id": 31,
          "name": "Home Construction & Furnishings"
        }, {
          "id": 32,
          "name": "Household Appliances & Housewares"
        }, {
          "id": 33,
          "name": "Leisure Goods & Services"
        }, {
          "id": 34,
          "name": "Personal Products"
        }]
      }, {
        "id": 6,
        "name": "Financial Services",
        "industriegruppen": [{
          "id": 14,
          "name": "Diversified Financial"
        }, {
          "id": 63,
          "name": "Private Equity & Venture Capital"
        }, {
          "id": 15,
          "name": "Real Estate"
        }, {
          "id": 16,
          "name": "Securities Brokers"
        }]
      }, {
        "id": 19,
        "name": "Green Technology",
        "industriegruppen": [{
          "id": 65,
          "name": " Agriculture & Resources Preservation"
        }, {
          "id": 66,
          "name": "Energy Efficiency & Reduction of Emission"
        }, {
          "id": 64,
          "name": "Renewable Energies"
        }]
      }, {
        "id": 8,
        "name": "Industrial",
        "industriegruppen": [{
          "id": 22,
          "name": "Advanced Industrial Equipment"
        }, {
          "id": 28,
          "name": "Containers & Packaging"
        }, {
          "id": 23,
          "name": "Heavy Machinery"
        }, {
          "id": 24,
          "name": "Industrial Machinery"
        }, {
          "id": 27,
          "name": "Industrial Products & Services"
        }, {
          "id": 25,
          "name": "Industrial, Diversified"
        }]
      }, {
        "id": 17,
        "name": "Insurance",
        "industriegruppen": [{
          "id": 57,
          "name": "Insurance"
        }, {
          "id": 58,
          "name": "Re-Insurance"
        }]
      }, {
        "id": 10,
        "name": "Media",
        "industriegruppen": [{
          "id": 35,
          "name": "Advertising"
        }, {
          "id": 36,
          "name": "Broadcasting"
        }, {
          "id": 37,
          "name": "Movies & Entertainment"
        }, {
          "id": 38,
          "name": "Publishing & Printing"
        }]
      }, {
        "id": 12,
        "name": "Pharma & Biotech",
        "industriegruppen": [{
          "id": 43,
          "name": "Biotechnology"
        }, {
          "id": 42,
          "name": "Healthcare"
        }, {
          "id": 44,
          "name": "Medical Technology"
        }, {
          "id": 41,
          "name": "Pharmaceuticals"
        }]
      }, {
        "id": 20,
        "name": "Real Estate",
        "industriegruppen": [{
          "id": 68,
          "name": "Real Estate"
        }]
      }, {
        "id": 7,
        "name": "Retail",
        "industriegruppen": [{
          "id": 17,
          "name": "Retail, Catalog"
        }, {
          "id": 18,
          "name": "Retail, Food & Drug"
        }, {
          "id": 19,
          "name": "Retail, Internet"
        }, {
          "id": 20,
          "name": "Retail, Multiline"
        }, {
          "id": 21,
          "name": "Retail, Specialty"
        }]
      }, {
        "id": 13,
        "name": "Software",
        "industriegruppen": [{
          "id": 46,
          "name": "IT-Services"
        }, {
          "id": 45,
          "name": "Internet"
        }, {
          "id": 47,
          "name": "Software"
        }]
      }, {
        "id": 14,
        "name": "Technology",
        "industriegruppen": [{
          "id": 48,
          "name": "Communications Technology"
        }, {
          "id": 49,
          "name": "Electronic Components & Hardware"
        }, {
          "id": 50,
          "name": "Semiconductors"
        }]
      }, {
        "id": 15,
        "name": "Telecommunications",
        "industriegruppen": [{
          "id": 51,
          "name": "Fixed-Line Telecommunication"
        }, {
          "id": 53,
          "name": "Telecommunication Services"
        }, {
          "id": 52,
          "name": "Wireless Telecommunication"
        }]
      }, {
        "id": 16,
        "name": "Transportation",
        "industriegruppen": [{
          "id": 54,
          "name": "Airlines"
        }, {
          "id": 55,
          "name": "Logistics"
        }, {
          "id": 56,
          "name": "Transportation Services"
        }]
      }];
    }
  }

  nextTab(index, data) {
    this.disabled[index] = false;
    this.active = index;
    if (index == 2) {
      data.c = 'anmeldung.Teilnehmer';
      data.section = 2;
      data.anmeldung_typ = 2;
      /*
      data.teilnehmer_branche = 'Nicht notiertes Kapitalsuchendes Unternehmen';
      data.teilnehmer_teilnahme_tage = 110;
      */

      if (data.person_unternehmenstitel_add) {
        data.person_unternehmenstitel = data.person_unternehmenstitel_add;
      }

      if (data.teilnehmer_gebuehren2) {
        data.teilnehmer_gebuehren2 = 1;
      }

      this.emittentenService.setData(data).then((result) => {
        if (result && result.code) {
          this.active = 0;
          this.toastr.error(result.msg || 'Unbekannter Fehler. Bitte später erneut versuchen und/oder an eigenkapitalforum@deutsche-boerse.com wenden. ||| Unknown Error. Please try again later and/or email to eigenkapitalforum@deutsche-boerse.com');
          this.showError = true;
          this.errMsg = result.msg || 'Unbekannter Fehler. Bitte später erneut versuchen und/oder an eigenkapitalforum@deutsche-boerse.com wenden. ||| Unknown Error. Please try again later and/or email to eigenkapitalforum@deutsche-boerse.com';
          this.$location.hash('alert');
          this.$anchorScroll();
        } else {
            this.done = true;
            this.toastr.success('Die Anmeldung wurde erfolgreich abgeschickt. Eine Bestätigung wurde an ' + this.form.person_email + ' gesendet.');
            this.form = {
              user_type: 4
            };
            this.disabled = [false, true];
            this.active = 0;
          }
        });
    }
  }

  selectIndustry() {
    if (this.form.teilnehmer_industriegruppe_branche != 'misc') {
      var selected = $.grep(this.industries, (e) => {
        return e.id == this.form.teilnehmer_industriegruppe_branche;
      });
      this.subindustries = selected[0].industriegruppen;
    } else {
      this.subindustries = [];
    }
  }

  checkEmail(email) {
    this.emittentenService.checkEmail(email).then(
      (result) => {
        this.emailChecked = result;
      },
      (response) => {
        console.error(response);
      }
    );
  }

}

export default EinzelticketController;



// WEBPACK FOOTER //
// ./client/app/common/forms/einzelticket/einzelticket.controller.js